{
  "actions": {
    "delete": "Delete",
    "edit": "Edit"
  },
  "toast": {
    "saved": "Saved"
  },
  "studentTab": {
    "tabLabel": "Irish Dance"
  },
  "nav": {
    "overview": "Irish Dance"
  },
  "passes": {
    "heading": "Competition passes",
    "lede": "Dances passed (stars) by dance type and level.",
    "add": "Record pass",
    "noConfig": "Configure dance types and levels in Settings → Dance first.",
    "addTitle": "Record competition pass",
    "editTitle": "Edit competition pass",
    "danceType": "Dance type",
    "level": "Level",
    "competition": "Competition name",
    "date": "Competition date",
    "notes": "Notes",
    "errTypeLevel": "Choose a dance type and level.",
    "errCompetition": "Enter the competition name.",
    "errDate": "Choose a valid competition date.",
    "confirmDelete": "Remove this competition pass?",
    "noPasses": "No competition passes recorded yet."
  },
  "grades": {
    "heading": "Grade exams",
    "lede": "Numbered grade exams (1–12) achieved.",
    "add": "Record grade",
    "empty": "No grade exams recorded yet.",
    "addTitle": "Record grade exam",
    "editTitle": "Edit grade exam",
    "gradeNumber": "Grade",
    "examDate": "Exam date",
    "location": "Exam location",
    "notes": "Notes",
    "errDate": "Choose a valid exam date.",
    "confirmDelete": "Remove grade {n}?",
    "diplomaUploaded": "Diploma uploaded.",
    "confirmRemoveDiploma": "Remove the diploma scan?",
    "colGrade": "Grade",
    "colDate": "Exam date",
    "colLocation": "Location",
    "colDiploma": "Diploma",
    "download": "Download",
    "gradeN": "Grade {n}",
    "uploadDiploma": "Upload diploma",
    "replaceDiploma": "Replace diploma",
    "removeDiploma": "Remove diploma",
    "chooseFile": "Choose file…",
    "noFile": "No file selected",
    "currentAttached": "A scan is already attached",
    "fileHint": "PDF or image, max 25 MB"
  },
  "portal": {
    "title": "Irish Dance progress",
    "passesHeading": "Competition passes",
    "gradesHeading": "Grade exams",
    "noPasses": "No competition passes yet.",
    "noGrades": "No grade exams yet."
  },
  "overview": {
    "title": "Irish Dance — passes overview",
    "sub": "Competition passes across all students.",
    "danceType": "Dance type",
    "level": "Level",
    "allDanceTypes": "All dance types",
    "allLevels": "All levels",
    "colStudent": "Student",
    "colDanceType": "Dance type",
    "colLevel": "Level",
    "colCompetition": "Competition",
    "colDate": "Date",
    "empty": "No passes match these filters."
  }
}
